import React from "react";

import { template } from "@reco-m/core";

import { Namespaces, footerModel } from "@reco-w/policy-layout-models";

import { PageFooter as oldPageFooter } from "@reco-w/policy-layout-blocks";

export namespace PageFooter {
    export interface IProps<S extends IState = IState> extends oldPageFooter.IProps<S> { }

    export interface IState extends oldPageFooter.IState, footerModel.StateType { }

    export class Component<P extends IProps = IProps, S extends IState = IState> extends oldPageFooter.Component<P, S> {
        render() {
            return (
                <div className="footer">
                    <div className="container">
                        <div className={"flex footer-content"}>
                            <div className="text flex-item">
                                <div>版权所有：上海市奉贤区科学技术委员会</div>
                                <div>
                                    <span onClick={() => window.open("https://beian.miit.gov.cn/#/")}>沪ICP备19002230号-1</span>
                                </div>
                                <div>咨询电话：021-20231082-891 推荐使用360极速浏览器</div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.footer]);
}
